import { gridFilteredTopLevelRowCountSelector, gridPageSelector, gridPageSizeSelector, useGridApiContext, useGridSelector, } from '@mui/x-data-grid-premium';
import { StyledFooterHelper, StyledPagination } from './DataGrid.styles';
import DropDownButton from '../DropDownButton';
import { Grid } from '@mui/material';
import React from 'react';
import Text from '@innovyze/stylovyze/lib/components/Text';
import { useGlobalization } from '../../contexts';
import { ZIndex } from '../../types';
import { rem } from '../../utils';
const getPageCount = (rowCount, pageSize) => {
    if (pageSize > 0 && rowCount > 0) {
        return Math.ceil(rowCount / pageSize);
    }
    return 0;
};
export const DataGridPagination = () => React.createElement(React.Fragment, null);
export const DataGridFooter = (props) => {
    const { t } = useGlobalization();
    const { pageSizeOptions } = props;
    const apiRef = useGridApiContext();
    const page = useGridSelector(apiRef, gridPageSelector);
    const pageSize = useGridSelector(apiRef, gridPageSizeSelector);
    const visibleTopLevelRowCount = useGridSelector(apiRef, gridFilteredTopLevelRowCountSelector);
    const pageCount = getPageCount(props.rowCount ?? visibleTopLevelRowCount, pageSize);
    React.useEffect(() => {
        if (!props.autoRowSizing)
            if (pageSizeOptions?.length &&
                !pageSizeOptions.includes(pageSize)) {
                apiRef.current?.setPageSize(pageSizeOptions?.[0] ?? 1);
            }
    }, []);
    if (!props.pagination || !apiRef.current) {
        return React.createElement(React.Fragment, null);
    }
    else {
        return (React.createElement(Grid, { container: true, justifyContent: "space-between", p: 2, spacing: 2 },
            React.createElement(Grid, { item: true }, pageSizeOptions?.length && (React.createElement("div", { key: pageSize, style: {
                    display: 'grid',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gridTemplateColumns: 'auto auto',
                    gap: '1rem',
                } },
                React.createElement(Text, { variant: "text-large" }, t('Rows per page:')),
                React.createElement(DropDownButton, { arrow: true, color: "secondary", options: pageSizeOptions?.map(opt => ({
                        name: `${opt}`,
                        onClick: () => {
                            apiRef.current?.setPageSize(opt);
                        },
                        cy: `pagination-option-${opt}`,
                    })), variant: "text", initialSelectedIndex: pageSizeOptions.indexOf(pageSize) !== -1
                        ? pageSizeOptions.indexOf(pageSize)
                        : 0, placement: "bottom-start", popupZIndex: ZIndex.DropDownButtonMenu, buttonProps: {
                        style: {
                            minWidth: 'unset',
                            width: rem(50),
                        },
                    } })))),
            React.createElement(Grid, { item: true },
                React.createElement(Grid, { container: true, display: 'flex', direction: 'column' },
                    React.createElement(StyledPagination, { page: page + 1, count: pageCount, onChange: (event, value) => apiRef.current?.setPage(value - 1) }),
                    props.footerHelper && (React.createElement(StyledFooterHelper, { variant: "caption-small" }, props.footerHelper))))));
    }
};
